import {
  Certificate,
  Product,
  CertificateStatus,
  Coverage,
  Logging,
  DisplayData,
} from '@vcd-ecm-ui/Common';

export function getProducts(certificate: Certificate): string {
  if (!certificate.products) {
    return null;
  }

  const products: string[] = certificate.products.map((product: Product) => product.name);

  return products.join(', ');
}

export function getStatus(certificate: Certificate): string {
  if (!certificate.status) {
    return CertificateStatus.Pending.toString();
  }

  return certificate.status.toString();
}

export function getReason(certificate: Certificate): string {
  if (!certificate.coverages) {
    return null;
  }

  const reasons: string[] = [];

  // Loop through the Coverages
  certificate.coverages.forEach((coverage: Coverage) => {
    // Only add unqiue Reasons
    if (reasons.indexOf(coverage.reason.type) === -1) {
      reasons.push(coverage.reason.type);
    }
  });

  return reasons.join(', ');
}

export function getReviewDates(certificate: Certificate): string {
  if (!certificate.coverages) {
    return null;
  }

  const datesArray: string[] = [];

  certificate.coverages.forEach((coverage: Coverage) => {
    // Only add unqiue Dates
    if (datesArray.indexOf(coverage.reviewDate) === -1) {
      datesArray.push(coverage.reviewDate);
    }
  });

  return datesArray.join(', ');
}

export function getCertificateNumbers(certificate: Certificate): string {
  if (!certificate.coverages) {
    return null;
  }

  const certificateNumber: string[] = certificate.coverages.map((coverage: Coverage) => coverage.certificateNumber);

  return certificateNumber.join(', ');
}

export function additionalDocumentsExist(certificate: Certificate): boolean {
  const { supportingDocumentationImages } = certificate;

  return (supportingDocumentationImages !== null) && (supportingDocumentationImages.length > 0);
}

export function getSourceOptions(): DisplayData[] {
  const values: DisplayData[] = [];

  values.push({ data: 'ECW ', display: 'ECW' });
  values.push({ data: 'Manual', display: 'Manual' });
  values.push({ data: 'Import', display: 'Import' });

  return values;
}

export function combineNameCode(name: string, code: string): string {
  if (name && code) {
    return `${name}   (${code})`;
  }

  return code ? `(${code})` : name;
}
